import { z } from 'zod';
import { CloudInfoSchema } from './cloud.js';
/** Doc 52: minutes without use before a cloud machine stops itself; 0 = never. */
export const IdleMinutesSchema = z.union([z.literal(0), z.number().int().min(10).max(720)]);
export const IdleStateSchema = z.object({
    minutes: z.number().int().min(0).max(720),
    idleForMinutes: z.number().min(0),
    selfStop: CloudInfoSchema.shape.selfStop,
});
export const SetIdleStopRequestSchema = z.object({ minutes: IdleMinutesSchema });
export const IdleStopResponseSchema = z.object({ idle: IdleStateSchema });
/** What `system_status` reports (untrusted: validated). */
export const SystemStatusSchema = z.object({
    agentVersion: z.string().max(32),
    comfyui: z.object({ running: z.boolean(), version: z.string().max(32).nullable(), crashes: z.number().int().min(0), gaveUp: z.boolean() }),
    ram: z.object({ totalGb: z.number().min(0), availableGb: z.number().min(0) }),
    swap: z.object({ totalGb: z.number().min(0), usedGb: z.number().min(0) }),
    freeDiskBytes: z.number().int().min(0),
    memoryPressure: z.enum(['ok', 'high']),
    /** A cloud machine's idle self-stop (agent ≥ 0.11.0, doc 52). */
    idle: IdleStateSchema.optional(),
});
export const MachineStatusResponseSchema = z.object({
    status: SystemStatusSchema,
    updates: z.object({
        agent: z.object({ installed: z.string(), latest: z.string() }),
        comfyui: z.object({ installed: z.string().nullable(), pinned: z.string() }),
    }),
});
export const LogsQuerySchema = z.object({
    which: z.enum(['agent', 'comfyui']),
    lines: z.coerce.number().int().min(1).max(500).default(200),
});
export const LogsResponseSchema = z.object({ lines: z.array(z.string().max(10_000)).max(500) });
export const UpdateAgentResponseSchema = z.object({ updated: z.boolean() });
export const UpdateComfyResponseSchema = z.object({ version: z.string().max(32).nullable() });
//# sourceMappingURL=lifecycle.js.map